/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { memoizedFetchSitePersonalization } from '@jira/platform__services-personalization/src/services/site/index.tsx';

export const isSiteOptedOut = async (cloudId: string): Promise<boolean> => {
	const siteTraits = await memoizedFetchSitePersonalization({ cloudId });
	const optoutTraitValue = siteTraits.find((trait) => trait.name === 'optout_all_messages')?.value;
	return typeof optoutTraitValue === 'boolean' && optoutTraitValue;
};
